import 'bootstrap';
require('./location');